import type { Position } from '../../entities/position';

/**
 * The illustration on the homepage: a real position card with made-up numbers (€1,000 to start,
 * 10 % steps, shares doubling, 5 % target, level 1 bought, price close to the target).
 */
export const EXAMPLE: Position = {
  id: 0,
  status: 'open',
  instrument: {
    id: 0,
    isin: 'IE00B5BMR087',
    symbol: 'SXR8.DE',
    display_symbol: 'SXR8',
    name: 'iShares Core S&P 500 UCITS ETF (Acc)',
    currency: 'EUR',
    tick_size: '0.01',
    signal_symbol: '^GSPC',
    fractional: false,
    active: true,
  },
  entry_price: '100.00',
  initial_sum: '1000',
  initial_shares: '10',
  levels_count: 4,
  step_pct: '10',
  multiplier: '2',
  target_pct: '5',
  opened_at: '2026-09-01T09:30:00Z',
  closed_at: null,
  notes: '',
  levels: [
    {
      n: 0,
      planned_price: '100.00',
      planned_shares: '10',
      planned_cost: '1000.00',
      status: 'filled',
      triggered_at: null,
      fill: null,
    },
    {
      n: 1,
      planned_price: '90.00',
      planned_shares: '20',
      planned_cost: '1800.00',
      status: 'filled',
      triggered_at: null,
      fill: null,
    },
    {
      n: 2,
      planned_price: '81.00',
      planned_shares: '40',
      planned_cost: '3240.00',
      status: 'pending',
      triggered_at: null,
      fill: null,
    },
    {
      n: 3,
      planned_price: '72.90',
      planned_shares: '80',
      planned_cost: '5832.00',
      status: 'pending',
      triggered_at: null,
      fill: null,
    },
    {
      n: 4,
      planned_price: '65.61',
      planned_shares: '160',
      planned_cost: '10497.60',
      status: 'pending',
      triggered_at: null,
      fill: null,
    },
  ],
  fills: [],
  holding: { shares: '30', cost: '2800.00', average: '93.3333', target_price: '98.00' },
  quote: {
    price: '96.20',
    previous_close: '95.10',
    day_change_pct: '1.16',
    ts: '2026-10-05T13:00:00Z',
  },
  valuation: {
    price: '96.20',
    market_value: '2886.00',
    pl: '86.00',
    pl_pct: '3.07',
    to_target_pct: '1.87',
  },
  realized: null,
  next_level: { n: 2, price: '81.00', distance_pct: '-15.80' },
  remaining_capital: '19569.60',
  deepest_level: 1,
  open_alerts: 0,
  regime_at_entry: null,
};
